
import Api from "@/services/Api";
import { computed, defineComponent, onMounted, ref, Ref, watch } from "vue";
import { useRoute } from "vue-router";
import { Modal } from "bootstrap";
import Title from "@/components/Title.vue";
import Button from "@/components/Button.vue";
import ModalCreateEditBandeira from "./components/ModalCreateEditBandeira.vue";
import useEmitter from "@/composables/Emmiter";
import Pagination from "@/components/Pagination.vue";
import _Skeleton from "element-plus/lib/el-skeleton";

interface Bandeira {
  codBandeira: number | null;
  cor1: string;
  cor2: string;
  cor3: string;
  created_at: string;
  descricao: string;
  fornecedorFiltroAc: string | null;
  fornecedorFiltroAr: string | null;
  fornecedorFiltroCombustivel: string | null;
  fornecedorFiltroOleo: string | null;
  fundoBg: string;
  imgBandeira: string;
  imgDestaque: string;
  imgModal: string | null;
  updated_at: string;
}

export default defineComponent({
  name: "Bandeiras",
  components: {Title, Button, ModalCreateEditBandeira, Pagination},
  props: [],
  setup() {
    const route = useRoute();
    const paramsProdutos: Ref<any> = ref({ pagina: 1, limite: 20, input: '' })
    const emitter = useEmitter()
    const auxModal: Ref<any> = ref(null);
    const bandeiras: Ref<Bandeira[]> = ref([]);
    const bandeiraSelected: Ref<Bandeira> = ref({
      codBandeira: null,
            cor1: "",
            cor2: "",
            cor3: "",
            created_at: "",
            descricao: "",
            fornecedorFiltroAc: "",
            fornecedorFiltroAr: "",
            fornecedorFiltroCombustivel: "",
            fornecedorFiltroOleo: "",
            fundoBg: "",
            imgBandeira: "",
            imgDestaque: "",
            imgModal: "",
            updated_at: "",
    });
    const totalBandeiras: Ref<number> =ref(0)
      // Constante de busca pelo filtro rápido
    const inputFind: Ref<string> = ref('')

      // Constantes de paginação (pagina e limite)
    const page: Ref<number> = ref(1)
    const limite: Ref<number> = ref(10);
    const skeleton: Ref<boolean> = ref(false);
    const pagination = ref<InstanceType<typeof Pagination> | null>(null);

      //Buscar todas as bandeiras
    async function getAllBandeiras() {
      try {
        skeleton.value = true
        const { data } = await Api.post("bandeirasPaginado", { //Requisição a API de buscar bandeiras
          pagina: page.value,
          limite: limite.value,
          input: inputFind.value
        });
        skeleton.value = false
        bandeiras.value = data.original.bandeiras;
        totalBandeiras.value = data.original.totalBandeiras
      } catch (error) {
        console.log(error);
      }
    }

    //Busca por uma bandeira clicada
    async function clickedBandeira(id: number | null) {
      try {
        const {data} = await Api.get('getBandeira', {codBandeira: id})
        bandeiraSelected.value = data        
      } catch (error) {
        console.log(error)
      }
    }
    
    const openModal = (id, type = 'default') => {
      if(type === 'create'){
        bandeiraSelected.value = {
            codBandeira: null,
            cor1: "",
            cor2: "",
            cor3: "",
            created_at: "",
            descricao: "",
            fornecedorFiltroAc: "",
            fornecedorFiltroAr: "",
            fornecedorFiltroCombustivel: "",
            fornecedorFiltroOleo: "",
            fundoBg: "",
            imgBandeira: "",
            imgDestaque: "",
            imgModal: "",
            updated_at: "",
          }
        }
      const auxElement = document.querySelector(`#${id}`);
      auxModal.value = new Modal(auxElement);
      auxModal.value.show();

    };
    
    function closeModal(): void {
      auxModal.value.hide()
      auxModal.value = null
    }

    emitter.on("removeBandeiraLista", (valor: any) => {

      const index = bandeiras.value.findIndex(({codBandeira}) => codBandeira === valor.id)

      if(index !== -1) bandeiras.value.splice(index,1)

      })
    
      //Condição para quando conter algum texto no input de busca
    watch(
      () => inputFind.value,
      () => {
        if(inputFind.value.length > 2 || !inputFind.value) {
            page.value = 1;
            if (pagination.value) {
              pagination.value.resetPage(1);
            } 
            getAllBandeiras()
        }
      }
    )

    function handlePageChange(pageParam) {
      page.value = pageParam;
      getAllBandeiras();
    }
    
    onMounted(() => getAllBandeiras())
    
    return { 
      bandeiras, 
      clickedBandeira, 
      totalBandeiras, 
      inputFind, 
      openModal, 
      closeModal, 
      bandeiraSelected, 
      getAllBandeiras,
      route,
      handlePageChange,
      pagination,
      skeleton
    };
  },
});
